export const MinimumFinancialYear = 2022;
